import { render } from "./TheSidebar.vue?vue&type=template&id=951de458&scoped=true"
import script from "./TheSidebar.vue?vue&type=script&lang=js"
export * from "./TheSidebar.vue?vue&type=script&lang=js"

import "./TheSidebar.vue?vue&type=style&index=0&id=951de458&scoped=true&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-951de458"]])

export default __exports__